import React, { useState } from 'react';
import api from '../services/api';

export default function QuickListManager({
  open,
  title,
  items = [],
  apiBase,
  extraBody = {},
  onClose,
  onChanged,
  extraFields = [],   // optional [{key,label,type,placeholder,parser?}] to add columns beyond code/name
  inline = false,     // when true, render without modal overlay
}) {
  const blank = () => {
    const o = { code: '', name: '' };
    extraFields.forEach(f => { o[f.key] = ''; });
    return o;
  };
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState(blank());
  const [newForm, setNewForm] = useState(blank());
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  if (!open) return null;

  const buildPayload = (form) => {
    const body = { ...extraBody, code: form.code, name: form.name };
    extraFields.forEach(f => {
      const raw = form[f.key];
      body[f.key] = f.parser ? f.parser(raw) : raw;
    });
    return body;
  };

  const startEdit = (it) => {
    const o = { code: it.code || '', name: it.name || '' };
    extraFields.forEach(f => { o[f.key] = it[f.key] != null ? String(it[f.key]) : ''; });
    setEditingId(it.id); setEditForm(o); setErr('');
  };
  const cancelEdit = () => { setEditingId(null); setEditForm(blank()); };

  const saveEdit = async () => {
    if (!editForm.name.trim()) { setErr('Ad zorunlu'); return; }
    setBusy(true); setErr('');
    try {
      await api.put(`${apiBase}/${editingId}`, buildPayload(editForm));
      cancelEdit();
      onChanged && (await onChanged());
    } catch (e) { setErr(e.response?.data?.message || e.message); }
    finally { setBusy(false); }
  };

  const remove = async (id) => {
    if (!window.confirm('Silinsin mi?')) return;
    setBusy(true); setErr('');
    try {
      await api.delete(`${apiBase}/${id}`);
      onChanged && (await onChanged());
    } catch (e) { setErr(e.response?.data?.message || e.message); }
    finally { setBusy(false); }
  };

  const addNew = async () => {
    if (!newForm.name.trim()) { setErr('Ad zorunlu'); return; }
    setBusy(true); setErr('');
    try {
      await api.post(apiBase, buildPayload(newForm));
      setNewForm(blank());
      onChanged && (await onChanged());
    } catch (e) { setErr(e.response?.data?.message || e.message); }
    finally { setBusy(false); }
  };

  const renderExtraInputs = (form, setForm) => extraFields.map(f => (
    <input key={f.key} className="qlm-input qlm-extra" type={f.type || 'text'} placeholder={f.placeholder || f.label}
      value={form[f.key] ?? ''}
      onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} />
  ));
  const renderExtraText = (it) => extraFields.map(f => (
    <div key={f.key} className="qlm-extra-text">{it[f.key] != null && it[f.key] !== '' ? `${f.label}: ${it[f.key]}` : ''}</div>
  ));

  const body = (
    <>
      {!inline && <h3>{title} — Tanımlar</h3>}
      {err && <div className="qlm-err">{err}</div>}

      <div className="qlm-list">
        {items.length === 0 && <div className="qlm-empty">Kayıt yok</div>}
        {items.map(it => (
          <div key={it.id} className="qlm-row" style={extraFields.length ? { gridTemplateColumns: `90px 1fr ${extraFields.map(()=>'80px').join(' ')} auto auto` } : undefined}>
            {editingId === it.id ? (
              <>
                <input className="qlm-input qlm-code" value={editForm.code} placeholder="Kod"
                  onChange={e => setEditForm(p => ({ ...p, code: e.target.value }))} />
                <input className="qlm-input qlm-name" value={editForm.name} placeholder="Ad"
                  onChange={e => setEditForm(p => ({ ...p, name: e.target.value }))} />
                {renderExtraInputs(editForm, setEditForm)}
                <button className="qlm-btn qlm-save" disabled={busy} onClick={saveEdit}>Kaydet</button>
                <button className="qlm-btn qlm-cancel" disabled={busy} onClick={cancelEdit}>İptal</button>
              </>
            ) : (
              <>
                <div className="qlm-code-text">{it.code || '—'}</div>
                <div className="qlm-name-text">{it.name}</div>
                {extraFields.length > 0 && extraFields.map(f => (
                  <div key={f.key} className="qlm-extra-text">{it[f.key] != null && it[f.key] !== '' ? it[f.key] : '—'}</div>
                ))}
                <button className="qlm-btn qlm-edit" onClick={() => startEdit(it)}>Düzenle</button>
                <button className="qlm-btn qlm-del" disabled={busy} onClick={() => remove(it.id)}>Sil</button>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="qlm-add" style={extraFields.length ? { gridTemplateColumns: `90px 1fr ${extraFields.map(()=>'80px').join(' ')} auto` } : undefined}>
        <input className="qlm-input qlm-code" placeholder="Kod" value={newForm.code}
          onChange={e => setNewForm(p => ({ ...p, code: e.target.value }))} />
        <input className="qlm-input qlm-name" placeholder="Ad *" value={newForm.name}
          onChange={e => setNewForm(p => ({ ...p, name: e.target.value }))} />
        {renderExtraInputs(newForm, setNewForm)}
        <button className="btn-primary-sm" disabled={busy} onClick={addNew}>+ Ekle</button>
      </div>

      {!inline && (
        <div className="modal-actions">
          <button className="btn-ghost" onClick={onClose}>Kapat</button>
        </div>
      )}
    </>
  );

  if (inline) return <div className="qlm-inline">{body}</div>;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box qlm-box" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        {body}
      </div>
    </div>
  );
}
